/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';

function useOnMutationSettled(
  mutationFlags: Array<boolean | undefined>,
  onSettled: () => void,
): void {
  const signature = mutationFlags.map((flag) => (flag ? '1' : '0')).join('');
  const previousSignatureRef = useRef<string>(signature);

  useEffect(() => {
    const previous = previousSignatureRef.current;
    const settled = signature
      .split('')
      .some((flag, index) => flag === '1' && previous[index] === '0');
    previousSignatureRef.current = signature;
    if (settled) onSettled();
  }, [signature]);
}

export default useOnMutationSettled;
